module.exports = __webpack_public_path__ + "static/slide_1_3-94b4bdb4de8848ec769aed3e2cc72084.svg";